<template>
  <div class="rounded overflow-hidden shadow-lg bg-white py-4 px-8">
    <slot></slot>
  </div>

</template>